import { makeStyles } from "@material-ui/core";

export const searchItemStyle = ({ over }) => {
  const classes = makeStyles({
    address: {
      cursor: "pointer",
      textAlign: "right",
      marginBottom: "5px",
      transition: "0.5s",
      width: "98%",
      borderRadius: "5px",
      padding: "12px 8px",
      "&:hover": {
        backgroundColor: "#324a67"
      }
    },

    addressText: {
      color: "#00d4ff",
      fontSize: "1.1rem",
      fontWeight: "700",
      direction: "rtl",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },

    item: {
      width: 'fit-content',
      position: 'relative',
      right: 0,
      transition: "1.5s"
    },

    moveItem: {
      animation: `$move ${over / 12}s linear infinite`,
      right: 0
    },
    "@keyframes move": {
      "0%": {
        right: 0,
      },
      "5%": {
        right: 0,
      },
      "50%": {
        right: -over,
      },
      "100%": {
        right: -over,
      },
    },
  })

  return classes()
}